module.exports = __webpack_public_path__ + "4015573cbdcd42073e61923e27b7f9d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/offers/assets/default-deal-img.jpg
// module id = 6432
// module chunks = 25